const newsCardList = document.querySelector('.news-list');
if (newsCardList) {
  /* ----------------------------------------
   * Helpers
   * ------------------------------------- */

  const getParent = (el) => el.closest('.sc-general');
  const updateUrl = ({ activeButtonValue, activeDropdownValue, pageNumber }) => {
    const [baseUrl] = window.location.href.split('?');

    const params = new URLSearchParams();

    if (activeButtonValue) {
      params.set('filter', activeButtonValue);
    }

    if (activeDropdownValue) {
      if (activeDropdownValue !== 'all') {
        params.set('scope', activeDropdownValue);
      } else {
        params.delete('scope');
      }
    }

    if (pageNumber && pageNumber !== '1') {
      params.set('pageNumber', pageNumber);
    }

    const queryString = params.toString();
    window.history.pushState({}, '', queryString ? `${baseUrl}?${queryString}` : baseUrl);
  };

  /* ----------------------------------------
   * Axios
   * ------------------------------------- */

  const fetchArticleList = async ({ parent, pageNumber = '' }) => {
    const action = parent.querySelector('[data-action]')?.value || 'getNewsList';

    const listInner = parent.querySelector('.news-list');
    const pagination = parent.querySelector('.news-list__pagination');

    const { kIndex } = getQueryConfig(parent);

    try {
      const { data } = await axios.post(localData.siteURL, {
        action,
        id: localData.id,
        kIndex: String(kIndex),
        pageNumber,
        nonce: await getNonceForAction(action),
      });

      if (listInner && data?.data?.html_list) {
        listInner.innerHTML = data.data.html_list;
      }

      if (pagination && data?.data?.html_pagination) {
        pagination.innerHTML = data.data.html_pagination;
      }

      updateUrl({ pageNumber });
      newsCardList.scrollIntoView();
    } catch (error) {
      console.error(error);
    }
  };

  const getQueryConfig = (parent) => {
    const inner = parent.querySelector('.news-list');

    return {
      kIndex: inner?.dataset.queryKIndex ?? '',
    };
  };

  /* ----------------------------------------
   * Event Handlers
   * ------------------------------------- */

  const handleFilterChange = (ev) => {
    ev.preventDefault();

    const parent = getParent(ev.target);

    const pageNumber = ev.target.dataset.page || '';

    fetchArticleList({
      parent,
      pageNumber,
    });
  };

  // Pagination
  attachEvent('.news-list .page-numbers, .content-module__pagination .page-numbers', 'click', handleFilterChange);
}
